











/* General */
import Vue from 'vue'
import moment from 'moment'

/* Mixins */

/* Components */
import chicklet from './chicklet.vue'

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'DueDateChicklet',

  components: {
    chicklet,
  },

  props: {
    dueDate: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'tiny',
    },
  },

  computed: {
    isDueDateOverdue(): boolean {
      if (this.dueDate) {
        return moment(new Date()).isAfter(this.dueDate)
      }
      return false
    },

    isDueDateInTwoDays(): boolean {
      if (this.dueDate) {
        return moment(new Date()).isAfter(
          moment(this.dueDate).subtract(2, 'days'),
        )
      }
      return false
    },

    dueDateColor(): string {
      if (this.isDueDateOverdue) {
        return 'strawberry'
      } else if (this.isDueDateInTwoDays) {
        return 'light-orange'
      } else {
        return 'grey'
      }
    },

    dueDateFormatted(): string {
      if (this.dueDate) {
        if (moment(this.dueDate).isSame(new Date(), 'year')) {
          return moment(this.dueDate).format('MMM D')
        } else {
          return moment(this.dueDate).format('MMM D, YYYY')
        }
      }
    },
  },
})
